<template>
  <div class="form-group">
    <label v-if="label" class="form-label text-muted">
      {{ label }} <i v-if="required" class="text-danger">*</i>
    </label>
    <!-- a linha inteira é o label: o texto e o quadradinho marcam a opção -->
    <label
      v-for="(item, index) in options"
      :key="'option_' + index"
      :for="name + '_' + index"
      class="d-flex align-items-center mb-0 cursor-pointer"
      :class="{ 'border-bottom': options.length > index + 1 }"
    >
      <span class="text-paragraph flex-fill py-3">
        {{ item.name || item.title }}
      </span>
      <input
        hidden
        type="radio"
        v-model="model.$model"
        :value="item.id"
        :id="name + '_' + index"
        :name="name"
        @change="onChange($event)"
      />
      <i
        class="fa-solid fa-check fa-xl text-secondary radio-checked"
        v-if="model.$model == item.id"
      ></i>
      <!-- quadradinho vazio: só aparece dentro de .app-form (visual do app) -->
      <i v-else class="radio-unchecked"></i>
    </label>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    model?: any;
    label?: string;
    options?: any[];
    required?: boolean;
    name: string;
  }>(),
  {
    model: () => ({}),
    label: "",
    options: () => [],
    required: false,
    name: "",
  },
);

const emit = defineEmits<{
  onChange: [value: string];
}>();

const onChange = (event: Event) => {
  emit("onChange", (event.target as HTMLInputElement).value);
};
</script>
